export default "__VITE_ASSET__FbJiM82i__"